import { Component, Input } from '@angular/core';
import { TableFilterService } from '@shared/layout/services/table-filter.service';

@Component({
    selector: 'sume-table-filter',
    templateUrl: './table-filter.component.html',
})
export class TableFilterComponent {
    @Input() filters: string[];

    constructor(public tableFilterService: TableFilterService) {}
}
